import React, {
  TextareaHTMLAttributes,
  useEffect,
  useRef,
  useState,
} from "react";
import Select from "../select";
import SelectCreate from "../select-create";
import useCreateProjectFacade from "../../../facade/createProject.Facade";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../store/hooks/StoreHooks";
import {
  setCountry,
  setStateList,
  setCounty,
  setProjectName,
  setCaseName,
  setReprestative,
  setFormation,
  setContact,
  setCountyOther,
  setState,
  setWellApiNo,
  setCaseDescription,
} from "../../../store/dashboard/CreateProjectSlice";
import { setProjectTabDetails } from "../../../store/calculation/calculation-input/ProjectTabSlice";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Textarea from "../textarea";
import useReportFacade from "../../../facade/report/report.facade";
import { setIsProjectDetails, setIsReports } from "../../../store/reports/reportsSlice";
import { transformObjectToKeyValueArray } from "../../../utilities/commonUtilities";
import TextShortInput from "../TextShortInput";
import TextInput from "../textinput";
import { ProjectStatus } from "../../../utilities/AppConstants";
import Button from "../text-button-group";
import { designTypeButtonOptions } from "../../../constants/columns/projectdetails/buttonGroup";
import { LABELS } from "../../../constants/labels/jetlift/jetlift.labels";
const options = [
  { value: "0", label: "Active" },
  { value: "1", label: "International" },
  { value: "2", label: "Permian" },
  { value: "3", label: "Active + Obsolete" },
];

interface CreateProjectProps {
  syncFormToProjectTab?: boolean;
}

const CreateProject: React.FC<CreateProjectProps> = ({ syncFormToProjectTab = true }) => {
  const dispatch = useAppDispatch();
  const { updateIsProjectDetails } = useReportFacade();

  useEffect(() => {
    dispatch(setIsProjectDetails(true))
    dispatch(setIsReports(false))
  }, []);

  const handleOnChangeSelect = async (option: any, name: string = "") => {
    if (name === "equpiment") {
      const selectedValue = parseInt(option.value);
      updateEqupiment(selectedValue);
    } else if (name === "well") {
      if (option?.target?.value) {
        updateWell(option?.target?.value);
      } else {
        userHasEditedRef.current = true; // well selection populates form; don't let later API overwrite
        updateStateList(option.value);
        updateCountry(option.value);
        updateWell(option?.label || "");
        updateWellID(option?.value || 0);
        updateCounty(option.value);
        updateWellApiNo("");
        setState("");
        setStateList([]);
        updateCounty("");
        updateCountyList([]);
        updateState("");
        setIsOperatorContactAutoPopulated(!!option?.operatorContact);
        await loadWellDetailsById(option?.label, option?.country, option?.state, option?.county, option?.apino, option);
        handleWellClose();
      }
    } else if (name === "country") {
      updateCountry(option.value);
      updateStateList("");
      updateCountyList("");
      if (option?.value) {
        await loadState(option.value).then((response) => {
          setStateList(response?.payload);
        });
      }
      setCountry(option.value);
      updateDuplicateCountyList([]);
      updateCountyList([]);
      updateOtherCounty("");
      updateCounty("");
      await loadCountry();
    } else if (name === "state") {
      updateCounty("");
      updateCountyList("");
      if (option?.value) {
        await loadCounty(option.value);
        updateState(option.value);
      }
      updateStateList(duplicateStateList);
      await loadState(`${country}`)
    } else if (name === "county") {
      setCounty(option.value);
      updateCountyList(duplicateCountyList);
      updateCounty(option.value);
    } else if (name === "customer") {
      if (option?.target?.value) {
        updateCustomer(option?.target?.value);
      } else {
        updateCustomer(option?.label || "");
        updateCustomerID(option?.value || null);
        updateContact("");
        updateCustomerSearch("");
        setIsOperatorContactAutoPopulated(false);
      }
    } else if (name === "accountManager") {
      updateAccountManager(option?.value);
      updateAccountManagerList(accountManagerDuplicateList);
    }
  };

  const handleClearWell = () => {
    updateWell("");
    updateWellID(0);
    updateWellApiNo("");
    updateCounty("");
    updateCountry("");
    updateState("");
    updateCountyList([]);
    updateStateList([]);
    updateOtherCounty("");
    updateWellSearch("");
    updateCustomer("");
    updateCustomerID(null);
    updateContact("");
    updateFormation("");
    setIsOperatorContactAutoPopulated(false);
  }

  const handleClearCustomer = () => {
    updateCustomer("");
    updateCustomerID(null);
    updateContact("");
    updateCustomerSearch("");
    setIsOperatorContactAutoPopulated(false);
  }

  const handleOnChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    userHasEditedRef.current = true;
    const { name, value } = event.target;
    if (name === "projectName") {
      dispatch(setProjectName(value));
    } else if (name === "caseName") {
      dispatch(setCaseName(value));
    } else if (name === "represtative") {
      dispatch(setReprestative(value));
    } else if (name === "formation") {
      dispatch(setFormation(value));
    } else if (name === "contact") {
      dispatch(setContact(value));
      setIsOperatorContactAutoPopulated(false);
    } else if (name === "otherCounty") {
      dispatch(setCountyOther(value));
    } else if (name === "wellapi") {
      dispatch(setWellApiNo(value));
    } else if (name === "caseDescription") {
      dispatch(setCaseDescription(value));
    }
  };
  const handleOnChangeTextArea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    userHasEditedRef.current = true;
    const { name, value } = event.target;
    dispatch(setCaseDescription(value));
  };

  const {
    wellList,
    countryList,
    stateList,
    countyList,
    customerList,
    country,
    wellApiNo,
    state,
    county,
    projectName,    
    caseName,
    represtative,
    formation,
    contact,
    countyOther,
    well,
    wellID,
    duplicateCountryList,
    duplicateStateList,
    duplicateCountyList,
    customer,
    customerID,
    caseDescription,
    accountManagerList,
    accountManagerDuplicateList,
    accountManager,
    customerSearchKey,
    wellSearchKey,
    liftOption,
  } = useAppSelector((state) => state?.createProject);
  const { projectReadOnly } = useAppSelector((state) => state.projectHeader);

  const { projectAndAffiliations, loading } = useAppSelector(
    (state) => state?.projectHeader
  );

  const { projectDetails } = useAppSelector((state) => state?.calculations);
  const { tab4Input: projectTabInput } = useAppSelector((state) => state?.projectTab);
  const { customerEnabled, customerCreated} = useAppSelector((state) => state?.auth);
  const {
    loadWell,
    loadWellDetailsById,
    loadCountry,
    loadState,
    loadCounty,
    updateCountry,
    updateCountyList,
    updateStateList,
    updateWell,
    updateWellID,
    updateCounty,
    updateState,
    updateWellApiNo,
    updateCountryList,
    updateWellList,
    updateProjectName,
    updateContact,
    updateCaseName,
    updateFormation,
    updateReprestative,
    updateEqupiment,
    updateCustomer,
    updateCustomerID,
    updateCustomerList,
    UpdateUnitMeasurement,
    updateOtherCounty,
    UpdateCaseDescription,
    updateDuplicateCountyList,
    updateAccountManagerList,
    loadAccountManager,
    updateAccountManager,
    updateCustomerSearch,
    updateWellSearch,
    updateLiftOption,
  } = useCreateProjectFacade();

  const [unit, setUnit] = useState("Imperial");
  const [currentPage] = useState(1);
  const [pageSize] = useState(100);
  const handleClick = (selectedUnit: any) => {
    const unitValue = selectedUnit === "Imperial" ? 0 : 1;
    UpdateUnitMeasurement(unitValue);
  };
  const [isCountyError, setIsCountyError] = useState(false);
  const [isCreateFlag, setCreateFlag] = useState(false);
  const [isOperatorContactAutoPopulated, setIsOperatorContactAutoPopulated] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const lastSyncedProjectKeyRef = useRef<string>("");
  const userHasEditedRef = useRef<boolean>(false);

  // const { projectID, templateID } = useParams();
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    let errorMessage = "";

    if (name === "projectName" && value.trim().length < 1) {
      errorMessage = "Project name is required";
    } else if (name === "represtative" && value.trim().length < 1) {
      errorMessage = "Created by is required";
    } else if (name === "caseName" && value.trim().length < 1) {
      errorMessage = "Case name is required";
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };

  useEffect(() => {
    const fetchApi = async () => {
      await loadWell({
        pageNumber: 1,
        pageSize: 100,
        searchTerm: wellSearchKey ? wellSearchKey : "",
        SortBy: "wellName", 
        SortDirection: 0
      });
      await loadCountry();
      await loadAccountManager();
    };
    fetchApi();
  }, []);

  useEffect(() => {
    loadWell({ pageNumber: 1, pageSize: 100, searchTerm: wellSearchKey ? wellSearchKey : "", SortBy: "wellName", SortDirection: 0 });
  }, [wellSearchKey]);

  const { ID, caseID, templateID } = useParams();
  const projectID = ID?.split("projectID=")?.[1] || "";
  const caseId = caseID?.split("caseID=")?.[1] || "";
  const templateId = templateID?.split("templateID=")?.[1] || "";
  let projId = caseId !== "" ? caseId : projectID;
  const tempId = ID?.split("templateID=")?.[1] || templateId || "";
  
  // Get tab4Input from the correct source: ESP uses projectDetails.tab4Input, Jetlift uses projectTab.tab4Input
  const tab4Input = projectDetails?.tab4Input || projectTabInput;

  useEffect(() => {
    if (!projectAndAffiliations || projectAndAffiliations.length === 0) return;

    const matchedCase = caseId
      ? projectAndAffiliations.find((item: { projectID: string; }) => item.projectID === caseId)
      : undefined;

    const selectedCase = matchedCase ?? projectAndAffiliations[0];
    dispatch(setCaseName(selectedCase?.caseName?.trim()));
    dispatch(setCaseDescription(selectedCase?.caseDescription?.trim()));
    dispatch(setReprestative(selectedCase?.createdByName?.trim()));
    dispatch(updateAccountManager(selectedCase?.dalRep?.trim()));

  }, [caseId, projectAndAffiliations]);

  useEffect(() => {
    let tempValue = tab4Input;
    const hasESPData = projectDetails && Object.keys(projectDetails).length > 0 && projectDetails.tab4Input;
    const hasJetliftData = projectTabInput && Object.keys(projectTabInput).length > 0;
    const hasProjectData = hasESPData || hasJetliftData;
    const hasProjectId = projectID !== "" || caseId !== "" || templateId !== "";
    const projectKey = `${projectID}|${caseId}|${templateId}`;
    if (!hasProjectId) {
      lastSyncedProjectKeyRef.current = "";
      userHasEditedRef.current = false;
      return;
    }

    if (lastSyncedProjectKeyRef.current !== projectKey) {
      userHasEditedRef.current = false;
    }
    if (!(hasProjectData && tempValue && !userHasEditedRef.current)) {
      return;
    }
    lastSyncedProjectKeyRef.current = projectKey;

    if (tempValue !== null){
      updateProjectName(tempValue.projectName);
      updateContact(tempValue.customerContact);
      setIsOperatorContactAutoPopulated(!!tempValue?.customerContact?.trim?.());
      updateCaseName(tempValue.caseName);
      updateReprestative(tempValue.dalRepr ?? "");
      updateWellApiNo(tempValue.wellApiNo);
      updateFormation(tempValue.formation ?? "");
      const catalogType = projectDetails?.catalogType || 0;
      updateEqupiment(catalogType);
      setCreateFlag(projectAndAffiliations?.every((item: any) => item.status === ProjectStatus?.inProgress) ? false : true);
      updateCustomerID(tempValue?.customerCnxId ?? null);
      updateCounty(tempValue?.county);
      updateOtherCounty(tempValue?.countyOther);
      updateState(tempValue?.state);
    }
    

    if (tempValue?.wellName) {
      const trasformData = [...wellList];
      const findWell = wellList?.find(
        (item: any) => item.label === tempValue?.wellName
      );
      if ([0, null]?.includes(tempValue?.wellCnxId) || !findWell) {
         trasformData.unshift({
          value: tempValue?.wellCnxId ?? null,
          label: tempValue?.wellName,
        });
        updateWell(trasformData[0]?.label);
        updateWellID(trasformData[0]?.value);
      } else {
        updateWell(findWell?.label ?? "");
        updateWellID(findWell?.value ??"");
      }
      if (![0, null]?.includes(tempValue?.wellCnxId)){
        updateWellList(trasformData);
      } else{
        updateWellList(wellList);
      }
    }

    if (tempValue?.country && stateList?.length === 0) {
      loadState(tempValue?.country).then((response) => {
        if (response?.payload) {
          const stateArray = response?.payload?.map((item: any) => ({
            label: item?.stateName,
            value: item?.stateID,
          }));
          const findProjectState = stateArray?.find((item: any) => {
            return item.value === Number(tempValue?.state);
          });
          updateStateList(stateArray);
        }
        updateState(tempValue?.state);
      });
    }
    if (tempValue?.state && countyList?.length === 0) {
      loadCounty(tempValue.state).then((response) => {
        if (response?.payload) {
          const findcounty = Object.entries(response?.payload).map(
            ([Key, value]) => ({
              label: Key,
              value: value,
            })
          );
          const ConnCounty = findcounty?.find(
            (item: any) => item.value === tempValue?.county
          );
          updateCountyList(findcounty);
        }
      });
      updateCounty(tempValue?.county);
    } else if (tempValue?.state && (countyList?.[0]?.value === "-1" || countyList?.[0]?.value === "")) {
      updateOtherCounty(tempValue?.countyOther);
    } else {
      updateCountyList(transformObjectToKeyValueArray(tempValue?.countyList));
    }
    if (tempValue.country !== "0") {
      updateCountry(tempValue?.country);
    }

    if (tempValue?.companyName) {
      const customerData = [...customerList];
      const findCustomer = customerList?.find(
        (item: any) => item.value === tempValue?.customerCnxId
      );
      if ([0, null]?.includes(tempValue?.customerCnxId) || !findCustomer) {
         customerData.unshift({
          value: tempValue?.customerCnxId ?? null,
          label: tempValue?.companyName,
        });
        updateCustomer(customerData[0]?.label);
        updateCustomerID(customerData[0]?.value);
      } else {
        updateCustomer(findCustomer?.label ?? "");
        updateCustomerID(findCustomer?.value ??"");
      }
      if (![0, null]?.includes(tempValue?.customerCnxId)){
        updateCustomerList(customerData);
      } else{
        updateCustomerList(customerList);
      }
    }
  }, [projectDetails, projectID, caseId, templateId, tab4Input]);

  useEffect(() => {
    if (!syncFormToProjectTab) return;
    const tab4 = projectTabInput ?? {};
    const hasLoadedTab4Data = !!(tab4.projectName ?? tab4.customerContact ?? tab4.wellName ?? tab4.companyName);
    const hasCreateProjectData = !!(projectName || contact || well || customer || caseName);
    if (hasLoadedTab4Data && !hasCreateProjectData) {
      return;
    }
    dispatch(
      setProjectTabDetails({
        ...tab4,
        projectName: projectName ?? tab4.projectName,
        caseName: caseName ?? tab4.caseName,
        companyName: customer ?? tab4.companyName,
        customerContact: contact ?? tab4.customerContact,
        wellName: well ?? tab4.wellName,
        wellApiNo: (wellApiNo ?? tab4.wellApiNo) ?? "",
        formation: formation ?? tab4.formation,
        dalRepr: (accountManager ?? tab4.dalRepr) ?? "",
        country: (country ?? tab4.country) ?? "",
        state: (state ?? tab4.state) ?? "",
        county: (county ?? tab4.county) ?? "",
        countyOther: (countyOther ?? tab4.countyOther) ?? "",
      })
    );
  }, [
    syncFormToProjectTab,
    projectName,
    caseName,
    customer,
    contact,
    well,
    wellApiNo,
    formation,
    accountManager,
    country,
    state,
    county,
    countyOther,
  ]);

  const onChangeAccountManager = async (e: any) => {
    const { value } = e.target;
    if (value == "") {
      dispatch(updateAccountManagerList(accountManagerDuplicateList));
    } else {
      const filtered = accountManagerDuplicateList.filter((manager: any) => {
        if (!manager || !manager?.label) {
          return false;
        }
        const lowerCaseName = manager.label.toLowerCase();
        const includesSearch = lowerCaseName.includes(value.toLowerCase());
        return includesSearch;
      });
      dispatch(updateAccountManagerList(filtered));
    }
  }

  const onChangeSearchCountry = async (e: any) => {
    const { value } = e.target;
    if (value == "") {
      dispatch(updateCountryList(duplicateCountryList));
    } else {
      const filtered = duplicateCountryList.filter((country: any) => {
        if (!country || !country?.label) {
          return false;
        }
        const lowerCaseName = country.label.toLowerCase();
        const includesSearch = lowerCaseName.includes(value.toLowerCase());
        return includesSearch;
      });
      dispatch(updateCountryList(filtered));
    }
  };

  const onChangeSearchState = async (e: any) => {
    const { value } = e.target;
    if (value == "") {
      dispatch(updateStateList(duplicateStateList));
    } else {
      const filtered = duplicateStateList.filter((state: { label: string }) => {
        if (!state || !state?.label) {
          return false;
        }
        const lowerCaseName = state.label ? state.label.toLowerCase() : "";
        const includesSearch = lowerCaseName.includes(value.toLowerCase());
        return includesSearch;
      });

      dispatch(updateStateList(filtered));
    }
  };


  const onChangeSearchCounty = async (e: any) => {
    const { value } = e.target;
    if (value == "") {
      dispatch(updateCountyList(duplicateCountyList));
    } else {
      const filtered = duplicateCountyList.filter(
        (county: { label: string }) => {
          if (!county || !county?.label) {
            return false;
          }
          const lowerCaseName = county.label ? county.label.toLowerCase() : "";
          const includesSearch = lowerCaseName.includes(value.toLowerCase());
          return includesSearch;
        }
      );
      dispatch(updateCountyList(filtered));
    }
  };

  const onChangeSearch = async (e: any) => {
    const { value } = e.target;
    const keywordCount = value.trim();
    if (keywordCount.length >= 3) {
      updateWellSearch(value);
    } else if (keywordCount.length === 0) {
      updateWellSearch("");
    }
  };

  const handleWellClose = async () => {
    updateWellSearch("")
  }

  const handleCountryClose = async () => {
    await loadCountry()
  }

  const handleAccountManagerClose = () => {
    dispatch(updateAccountManagerList(accountManagerDuplicateList))
  }

  const handleStateClose = async () => {
    await loadState(`${country}`)
  }

  const handleCountyClose = async () => {
    await loadCounty(`${state}`)
  }

  const handleCustomerClose = async () => {
    updateCustomerSearch("");
  };

  const onChangeSearchCustomer = async (e: any) => {
    const { value } = e.target;
    const keywordCount = value.trim();
    if (keywordCount.length >= 3) {
      updateCustomerSearch(value);
    } else if (keywordCount.length === 0) {
      updateCustomerSearch("");
    }
  };

  useEffect(() => {
    const fetchApi = async () => {
      const isEmpty = (value: string | number) => value === "" || value === "-2";

      if (isEmpty(state) && county === "" && isEmpty(country) && isEmpty(well)) {
        setIsCountyError(false);
      }
      else if ((state !== "" && state !== "-2") && (country !== "" && country !== "-2") && (well !== "" && well !== "-2") && county === "") {
        setIsCountyError(false);
      }
      else if (well === "-2" && (state !== "" && state !== "-2") && (country !== "" && country !== "-2") && county === "") {
        setIsCountyError(false);
      }
      else if (isEmpty(country) && (isEmpty(state) || county !== "")) {
        setIsCountyError(true);
      }
      else if (!isEmpty(well) && !isEmpty(country) && (isEmpty(state) || county === "")) {
        setIsCountyError(true);
      }
      else if (county !== "" && (isEmpty(state))) {
        setIsCountyError(true);
      }
      else if ((state !== "" && county !== "") || (isEmpty(state) && county === "")) {
        setIsCountyError(false);
      }
      else {
        setIsCountyError(false);
      }
    };

    fetchApi();
  }, [well, state, county, country]);

  return (
    <div className="px-[24px] py-[16px]">
      <div className="py-[13px]"></div>
      <div className="text-lg text-primary-25 mb-[16px]">
        Project information
      </div>
      <div className="grid grid-cols-2 gap-[16px] mb-[16px]">
        <div className="">
          <TextInput
            label="Project name"
            placeholder="Enter project name"
            value={projectName}
            onBlur={handleBlur}
            required={true}
            disabled={customerEnabled}
            onChange={(event) => handleOnChangeInput(event)}
            name="projectName"
          />
          {errors.projectName && (
            <div className="text-error-700 text-sm mt-1 w-full">
              {errors.projectName}
            </div>
          )}
        </div>

        <div className="flex flex-col">
          <label
            className="text-[16px] text-neutral-25 mb-[6px]"
            style={{ color: "#F7F9F9" }}
          >
            Unit of measure
          </label>
          <div className="flex space-x-2 border border-[#4A5463] w-1/2 rounded-lg ">
            <button
              onClick={() => handleClick("Imperial")}
              className={`flex-1 px-4 py-2 rounded-l-lg button-border ${unit === "Imperial"
                ? "bg-gray-100 text-[#60BFDA]"
                : "bg-gray-100 hover:bg-gray-200 text-white"
                } transition-colors duration-200`}
            >
              Imperial
            </button>
            <button
              // onClick={() => handleClick("Metric")}
              className={`flex-1 px-4 py-2 rounded-r-lg disabled opacity-50 cursor-not-allowed ${unit === "Metric"
                ? "bg-gray-100 text-[#60BFDA]"
                : "bg-gray-100 hover:bg-gray-200 text-white"
                } transition-colors duration-200`}
            >
              Metric
            </button>
          </div>
        </div>
        <Button 
          label={LABELS?.designType} 
          required 
          buttonOptions={designTypeButtonOptions.map((option: any) => ({
            ...option,
            disabled: tempId !== "" || projId !== "",
          }))} 
          unit={liftOption?.designType} 
          handleClick={(value) => updateLiftOption({ designType: value, id: value === "ESP" ? 1 : 2 })} 
          width={"250px"} 
        />
      </div>
      <div className="grid grid-cols-2 gap-[16px] mb-[16px]">
        <div className="">
          <TextInput
            label="Case name"
            placeholder="Enter case name"
            value={caseName}
            onBlur={handleBlur}
            disabled={customerEnabled}
            required={true}
            maxLength={50}
            onChange={(event) => handleOnChangeInput(event)}
            name="caseName"
          />
          {errors.caseName && (
            <div className="text-error-700 text-sm mt-1 w-full">
              {errors.caseName}
            </div>
          )}
        </div>

        <SelectCreate
          options={accountManagerList || []}
          onChange={(option, name) => handleOnChangeSelect(option, name)}
          padding="px-[14px] sm:py-[10px] py-[5px]"
          fontSize="16px"
          className="sm:px-0 px-[10px]"
          selectedValue={accountManager}
          placeholder="Select account manager"
          label="Account manager"
          name="accountManager"
          targetName="accountManager"
          isSearch={true}
          onCloseDropdown={handleAccountManagerClose}
          onChangeSearch={onChangeAccountManager}
          textInput={false}
          disabled={customerEnabled}
        />
        {/* <div className="flex flex-col items-start">
          <label className="text-[16px] text-neutral-25 mb-[6px]">
            Created by
            <span className="ml-1 text-error-400">*</span>
          </label>
          <input
            placeholder="Enter created by"
            value={represtative}
            onBlur={handleBlur}
            required={true}
            onChange={(event) => handleOnChangeInput(event)}
            name="represtative"
            className="flex px-[12px] py-[10px] rounded-[8px] border-[1px] border-darkcolor-400 w-full bg-transparent text-neutral-25 focus:outline-none text-[16px] hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
          />
          {errors.represtative && (
            <div className="text-error-700 text-sm mt-1 w-full">
              {errors.represtative}
            </div>
          )}
        </div> */}
      </div>

      <div className="grid grid-cols-1 gap-[16px] mb-[16px]">
        <Textarea
          placeholder="Enter case description"
          label="Case description"
          value={caseDescription}
          onChange={(e) => handleOnChangeTextArea(e)}
          rows={2}
          maxLength={200}
          disabled={customerEnabled}
        ></Textarea>
      </div>
      <div className="py-[5px]"></div>
      <hr className="text-darkcolor-400 my-[16px]" />
      <div className="py-[5px]"></div>
      <div className="gap-[16px] mb-[16px] mt-[16px]">
        <label className="text-[18px] font-medium text-neutral-25">
          Well details
        </label>
      </div>
      <div className="grid grid-cols-2 gap-[16px]">
        <SelectCreate
          options={wellList || []}
          onChange={(option, name) =>{
            if (!isCreateFlag) {
              handleOnChangeSelect(option, name)
            }
          }}
          padding="px-[14px] sm:py-[10px] py-[5px]"
          fontSize="16px"
          className="sm:px-0 px-[10px]"
          selectedValue={well}
          textInput={false}
          placeholder="Select well"
          label="Well name"
          name="well"
          targetName="well"
          isSearch={true}
          showCloseIcon={true}
          onCloseDropdown={handleWellClose}
          onChangeSearch={onChangeSearch}
          onClear={handleClearWell}
          disabled={isCreateFlag || customerEnabled}
        />
        <div className="">
          <TextInput
            placeholder=""
            label="Well API #"
            value={wellApiNo}
            disabled={customerEnabled || [0, null, ""]?.includes(wellID) ? false : true || projectReadOnly}
            onChange={(event) => handleOnChangeInput(event)}
            name="wellapi"
            type="text"
          />
        </div>
      </div>
      <div className="gap-[16px] mb-[16px] mt-[16px]">
        <label className="text-[18px] font-medium text-neutral-25">
          Operator information
        </label>
      </div>
      <div className="grid grid-cols-2 gap-[16px] my-[16px]">
        <SelectCreate
          options={customerList || []}
          onChange={(option, name) => {
            if (!isCreateFlag) {
              handleOnChangeSelect(option, name);
            }
          }}
          padding="px-[14px] sm:py-[10px] py-[5px]"
          fontSize="16px"
          className="sm:px-0 px-[10px]"
          selectedValue={customer}
          textInput={false}
          placeholder="Select an operator"
          label="Operator"
          name="customer"
          targetName="customer"
          showCloseIcon={false}
          isSearch={false}
          onChangeSearch={onChangeSearchCustomer}
          onCloseDropdown={handleCustomerClose}
          onClear={handleClearCustomer}
          disabled={true}
        />
        <div className="">
          <TextInput
            label="Operator contact"
            placeholder=""
            value={contact}
            onChange={(event) => handleOnChangeInput(event)}
            name="contact"
            disabled={isCreateFlag || customerEnabled}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-[16px] my-[16px]">
        <Select
          options={countryList || []}
          onChange={(option, name) => handleOnChangeSelect(option, name)}
          padding="px-[14px] sm:py-[10px] py-[5px]"
          fontSize="16px"
          className="sm:px-0 px-[10px]"
          selectedValue={country}
          placeholder="Search & select country"
          label="Country"
          name="country"
          targetName="country"
          isSearch={true}
          onCloseDropdown={handleCountryClose}
          onChangeSearch={onChangeSearchCountry}
          disabled={customerEnabled}
        />
        <Select
          options={stateList || []}
          onChange={(option, name) => handleOnChangeSelect(option, name)}
          padding="px-[14px] sm:py-[10px] py-[5px]"
          fontSize="16px"
          className="sm:px-0 px-[10px]"
          selectedValue={state}
          placeholder="Search & select state"
          label="State"
          name="state"
          targetName="state"
          isSearch={true}
          onCloseDropdown={handleStateClose}
          onChangeSearch={onChangeSearchState}
          disabled={customerEnabled}
        />
      </div>

      <div className="grid grid-cols-2 gap-[16px] my-[16px]">
        <div className="relative">
          <Select
            options={countyList || []}
            onChange={(option, name) => handleOnChangeSelect(option, name)}
            padding="px-[14px] sm:py-[10px] py-[5px]"
            fontSize="16px"
            className="sm:px-0 px-[10px]"
            isNotFound={isCountyError}
            selectedValue={county}
            placeholder="Search & select county"
            label="County"
            name="county"
            targetName="county"
            isSearch={true}
            onChangeSearch={onChangeSearchCounty}
            onCloseDropdown={handleCountyClose}
            dropdownDirection="up"
            disabled={customerEnabled}
          />
          {isCountyError && (
            <p className="text-error-700 text-sm mt-1 w-full">
              State and county location mismatch
            </p>
          )}
        </div>
        <div className="">
          <TextInput
            label="Formation"
            placeholder="Enter formation"
            value={formation}
            onChange={(event) => handleOnChangeInput(event)}
            name="formation"
            disabled={customerEnabled}
            className="flex px-[12px] py-[10px] rounded-[8px] w-full bg-transparent text-neutral-25 focus:outline-none text-[16px] hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-[16px] my-[16px]">
        {county === "-1" && (
          <div className="">
            <TextInput
              label="County"
              placeholder="Enter other county"
              value={countyOther}
              onChange={(event) => handleOnChangeInput(event)}
              name="otherCounty"
              disabled={customerEnabled}
              className="flex px-[12px] py-[10px] rounded-[8px] border-[1px] border-darkcolor-400 w-full bg-transparent text-neutral-25 focus:outline-none text-[16px] hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateProject;
